import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a349d9214f1f20014ce3e50_1781932626934_55b48c83/koyambedutoday/src/app/product-detail/page.tsx");
